import { render, staticRenderFns } from "./TopSubB.vue?vue&type=template&id=68adc0c2&scoped=true&"
import script from "./TopSubB.vue?vue&type=script&lang=js&"
export * from "./TopSubB.vue?vue&type=script&lang=js&"
import style0 from "./TopSubB.vue?vue&type=style&index=0&id=68adc0c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68adc0c2",
  null
  
)

export default component.exports